import { render, staticRenderFns } from "./ModalImportResult.vue?vue&type=template&id=634bd6b4"
import script from "./ModalImportResult.vue?vue&type=script&lang=js"
export * from "./ModalImportResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports